import React, { useState, useEffect } from 'react';
import socket from '../socket';
import { wordCategories } from '../data/words';

const PlayerChoices = ({ gameSyncData, player, alertMessage }) => {
    const correctWord  = gameSyncData.game.currentWord;
    const [choices, setChoices] = useState([]);
    const [feedback, setFeedback] = useState('');
    const [feedbackType, setFeedbackType] = useState('');
    const [hasSubmitted, setHasSubmitted] = useState(false);
    const [selectedWord, setSelectedWord] = useState('');


    const handleChoice = (word) => {
        if (hasSubmitted) return;
        setSelectedWord(word);
        socket.emit('submit-guess', {
            roomId: gameSyncData.roomId,
            playerId: player.id,
            guess: word.trim()
        });
        setHasSubmitted(true);
    };
    
    useEffect(() => {
        if (feedbackType !== 'correct') {
            setFeedback('');
        }
        setHasSubmitted(false);
    }, [correctWord]);
       
    
    useEffect(() => {
        const playerFromSync = gameSyncData.players.find(p => p.id === player.id);
        setHasSubmitted(playerFromSync?.hasSubmitted || false);
    }, [gameSyncData]);
    

    useEffect(() => {
        const generateChoices = () => {
            const wrongChoices = wordCategories[gameSyncData.game.category]
                .filter(word => word !== correctWord)
                .sort(() => 0.5 - Math.random())
                .slice(0, 3);

            const mixedChoices = [...wrongChoices, correctWord].sort(() => 0.5 - Math.random());
            setChoices(mixedChoices);
        };
        generateChoices();
        
        socket.on('guessFeedback', ({ correct, message }) => {
            setFeedback(message);
            setFeedbackType(correct ? 'correct' : 'wrong');
            if (correct) {
                setTimeout(() => {
                    setFeedback('');
                    setFeedbackType('');
                }, 3000);
            }
        });
        
        
        return () => {
            socket.off('guessFeedback');
        };
    }, [correctWord, gameSyncData]);
    
    const buttonColors = [
          'bg-[#FF1111] hover:brightness-110 border-[#CC0F0F]', // red
          'bg-[#2A71F5] hover:brightness-110 border-[#1C50B0]', // blue
          'bg-[#00C033] hover:brightness-110 border-[#00992A]', // green
          'bg-[#FFA600] hover:brightness-110 border-[#CC8600]', // yellow/orange
        ];

return (
  <div className="space-y-6 text-center px-4">

      {alertMessage && (
          <p className="text-red-500 text-xs sm:text-sm md:text-base font-medium bg-red-50 border border-red-200 rounded-md px-3 py-2">
            ⚠️ {alertMessage}
          </p>
        )}

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mx-auto w-full">
      {choices.map((word, index) => {
        const baseColor = buttonColors[index % buttonColors.length];

        let buttonClass = `w-full min-h-[55px] sm:min-h-[80px] px-4 py-3 sm:px-5 sm:py-4
                          text-sm sm:text-base leading-snug text-center break-words
                          rounded-2xl font-bold shadow-md transition-all duration-300 border-2
                          flex items-center justify-center
                          `;

        if (hasSubmitted) {
          if (word === selectedWord) {
            buttonClass += feedback.toLowerCase().includes('correct')
              ? ' bg-green-500 text-white border-green-700 scale-105'
              : ' bg-red-500 text-white border-red-700 scale-105';
          } else {
            buttonClass += ' bg-gray-400 text-white cursor-not-allowed border-gray-600';
          }
        } else {
          buttonClass += ` ${baseColor} text-white hover:scale-105`;
        }

        return (
          <button
            key={index}
            className={buttonClass}
            onClick={() => handleChoice(word)}
            disabled={hasSubmitted}
          >
            {word}
          </button>
        );
      })}
    </div>

    {feedback && (
      <p
        className={`mt-4 text-lg sm:text-xl font-semibold ${
          feedback.toLowerCase().includes('correct')
            ? 'text-green-400'
            : 'text-red-400'
        }`}
      >
        {feedback.includes('Correct') ? '✅' : '❌'} {feedback}
      </p>
    )}
  </div>
);

      
};

export default PlayerChoices;